import React, { useMemo } from 'react';
import styled from 'styled-components';
import orderBy from 'lodash/orderBy';

import { useActiveHexContext } from 'shared/context';
import { Bold, Section } from 'components';

export const BigHex = () => {
  const { features, sqmtArea } = useActiveHexContext();

  const fixedHexFeatures = useMemo(() => {
    const hexFeatures = features ? Object.entries(features) : [];
    const sortedFeatures = orderBy(
      hexFeatures,
      (feature: any[]) => feature[1],
      ['desc'],
    ).map(feature => ({
      type: feature[0],
      area: Math.round(Number(feature[1])),
    }));
    return sortedFeatures;
  }, [features]);

  return (
    <Section column>
      <h2>Clicked big hex</h2>
      <div>
        <Bold>Hex sqmt:</Bold> {sqmtArea}m2
      </div>
      <FeatureTable>
        <tr>
          <th>Feature</th>
          <th>% of hex</th>
          <th>Sqmt</th>
        </tr>
        {fixedHexFeatures.map((feature: any, index: number) => {
          const featArea = sqmtArea
            ? Math.ceil(100 * (feature.area / sqmtArea))
            : 0;
          return (
            <tr key={`${feature.type}-${index}`}>
              <td>{feature.type}</td>
              <td>{featArea}%</td>
              <td>{feature.area}m2</td>
            </tr>
          );
        })}
      </FeatureTable>
    </Section>
  );
};

const FeatureTable = styled.table`
  margin: 8px;
  padding: 8px;
  border: 1px dotted grey;
  th {
    text-align: left;
  }
  th,
  td {
    width: 100px;
  }
`;
